import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EditPromoCode from "../../../components/SuperAdmin/PromoCode/EditPromoCode";

export default withRouter(connect()(EditPromoCode));
